var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnblockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5485 17.3437H19.7351C19.7205 17.324 19.7056 17.3045 19.691 17.285V16.3748C19.691 15.6198 20.3054 15.0054 21.0604 15.0054C21.8159 15.0054 22.4303 15.6198 22.4303 16.3748H23.9695C23.9695 14.7709 22.6647 13.4662 21.0604 13.4662C19.6979 13.4662 18.5551 14.4087 18.2406 15.675C17.1467 14.6778 15.854 13.8972 14.4262 13.409C16.5798 12.1674 18.0338 9.84268 18.0338 7.18294C18.0338 3.22232 14.8115 0 10.8511 0C6.89049 0 3.66817 3.22232 3.66817 7.18294C3.66817 9.8632 5.14478 12.2038 7.32634 13.438C3.06583 14.9318 0 19.0038 0 23.7832H1.5392C1.5392 18.5907 5.74533 14.3661 10.9152 14.3661C13.6884 14.3661 16.1803 15.5842 17.8986 17.5123C17.4412 17.7549 17.129 18.2354 17.129 18.788V22.556C17.129 23.3523 17.7768 24 18.573 24H23.5488C24.345 24 24.9923 23.3523 24.9923 22.556V18.7878C24.992 17.9915 24.3448 17.3437 23.5485 17.3437ZM5.20712 7.1832C5.20712 4.07119 7.73885 1.53946 10.8509 1.53946C13.9626 1.53946 16.4943 4.07119 16.4943 7.1832C16.4943 10.2952 13.9626 12.8269 10.8509 12.8269C7.7391 12.8269 5.20712 10.2949 5.20712 7.1832ZM23.4528 22.4603H18.6679V18.8829H23.4528V22.4603Z",
    fill: "#2BA62C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnblockIcon);
export default __webpack_public_path__ + "static/media/unblockIcon.26c983c86b329d4bcd9815885c3491d8.svg";
export { ForwardRef as ReactComponent };